import { tv } from 'tailwind-variants';

const aiLoaderStyles = tv({
    slots: {
        // Main container with horizontal layout and 8px gap
        base: `
      iris:flex
      iris:h-fit
      iris:w-fit
      iris:items-center
      iris:gap-(--base-space-px-8)
    `,
        // Image slot container with 32px height and 4px border radius
        imageSlot: `
      iris:flex
      iris:h-8
      iris:flex-shrink-0
      iris:items-center
      iris:justify-center
    `,
        // Text content using Body component styling
        textContent: `
      iris:flex
      iris:items-center
    `,
    },
    variants: {
        inverse: {
            false: "",
            true: "",
        },
    },
    defaultVariants: {
        inverse: false,
    },
});

export { aiLoaderStyles, aiLoaderStyles as default };
